import moment from 'moment';

// Hard date of earliest data shown on dashboards
export const DATA_START_DATE = '2017-06-01';

export const CURRENT_DATE = moment().format('YYYY-MM-DD');
